import { AppHelper } from "../appHelper.js";
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { EntityMachine } from "./definedMachinesGrid.js";
import React from "react";
export default class DefinedMachine extends React.Component<DefinedMachineProps, any>{
    private common = new AppHelper();
    constructor(props: DefinedMachineProps) {
        super(props)
        this.common.init(this);
    }

    save = async (closeAfterSave) => {
        let result = await HTTPService.post<JsonResultClass>("Machine/SaveProjectRegardedMachine", this.props.entity);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            $(window).trigger("serviceReportMachinesWorkedOnChanged", { update: true });
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
        this.common.handlePostSave(result.Code === 0, closeAfterSave);
        this.setState({});
    }

    private handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

export interface DefinedMachineProps extends AppBaseProps {
    entity: EntityMachine;
}